/**
 * Story 5.5 — de vastgestelde teksten bij *Soort aanpassen* (besluit V42,
 * 2026-08-16).
 *
 * De opdrachtgever heeft ze bevestigd zoals voorgelegd, zonder wijziging. Ze
 * zijn bindend onder KE-7, gelijk aan de rest van §10: over te nemen zoals ze
 * er staan, niet onderweg herformuleren. Elke tekst staat hier één keer — een
 * tweede formulering die "hetzelfde doet" is precies wat KE-7 uitsluit.
 *
 * De historieregel staat hier NIET: die wordt op de server gebouwd, uit de
 * auditrij, naast de andere historieteksten (`leaveRequestService.ts`). Twee
 * plekken die dezelfde zin opbouwen is dezelfde verdubbeling.
 */

/** De handeling bij een aanvraag die nog niet beoordeeld is. */
export const SOORT_ACTIE = 'Soort aanpassen';

/**
 * De uitleg in de bevestiging. Zij noemt het GEVOLG en niet het mechanisme —
 * welke kolommen erbij herschreven worden is niet de zorg van HR. Dezelfde
 * keuze als bij het terugnemen, waar de uitleg *"komt terug in je eigen
 * lijst"* zegt en niet welke status er wordt gezet.
 */
export const SOORT_BEVESTIGING_UITLEG =
  'Wie de aanvraag beoordeelt en of hij naar de loonadministratie gaat, kan hierdoor veranderen.';

/** De knop in de bevestiging: één woord, naar het model van §10.5. */
export const SOORT_BEVESTIGING_KNOP = 'Aanpassen';

/**
 * Wat de medewerker te zien krijgt bij de melding die de server uitstuurt
 * (`leave_request_soort_aangepast`).
 *
 * De reden wordt niet genoemd, en dat is een besluit: HR corrigeert hier een
 * keuze die de medewerker zelf heeft gemaakt, en een reden erbij zou lezen als
 * een terechtwijzing.
 *
 * ⚠️ Deze codebase kent vandaag nog geen scherm dat een SSE-melding per soort
 * uitschrijft — `useRealTimeUpdates` ververst alleen de gegevens. De tekst
 * staat hier zodat de story die dat scherm bouwt hem niet alsnog moet
 * verzinnen (KE-7).
 */
export const SOORT_MELDING_MEDEWERKER =
  'HR heeft de soort van je aanvraag aangepast naar calamiteiten- en zorgverlof.';
